import { render, staticRenderFns } from "./narrative-step.vue?vue&type=template&id=3ccb8535"
import script from "./narrative-step.vue?vue&type=script&lang=js"
export * from "./narrative-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports